import { Geolocation } from '@app-types/dealer.types'

export const coordinatesOfTheNetherlands: Geolocation = {
    lat: 52.6809187,
    lng: 5.0875302,
}

export const coordinatesOfDeEekhoornHeadQuarter: Geolocation = {
    lat: 52.1463388,
    lng: 5.2811913,
}
